/**
 * @Author: luoob
 * @Date: 2021-10-30 12:09:46
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-30 12:09:54
 * @Introduction: article storage 模块
 */

const MEDIA_PAGE_INDEX = 'mediaPageIndex'
 
const setMediaPageIndex = (content: string) => {
    localStorage.setItem(MEDIA_PAGE_INDEX, content)
}

const getMediaPageIndex = () => {
    return localStorage.getItem(MEDIA_PAGE_INDEX)
}
 
 
export default {
    setMediaPageIndex,
    getMediaPageIndex
}
 